<template>
  <el-card>
    <el-card style="margin: 30px 0 0 0" class="table">
      <el-row>
        <div class="basic">
          <h2>{{ $t('merchantdetails.basic') }}</h2>
          <table cellspacing="0" cellpadding="15">
            <thead>
              <tr>
                <th>{{ $t('clientmanage.table.merchantName') }}</th>
                <th>{{ $t('clientmanage.table.merchantNo') }}</th>
                <th>{{ $t('clientmanage.table.merchantEmail') }}</th>
                <th>{{ $t('clientmanage.table.merchantPhone') }}</th>
                <th>{{ $t('clientmanage.table.merchantStatus') }}</th>
                <th>{{ $t('clientmanage.table.merchantModel') }}</th>
                <th>{{ $t('merchantdetails.label.all') }}</th>
                <th>{{ $t('merchantdetails.label.usdt_qr') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ merchantInfo.merchantName }}</td>

                <td>{{ merchantInfo.merchantNo }}</td>
                <td>{{ merchantInfo.email }}</td>
                <td>{{ merchantInfo.phone }}</td>

                <td>
                  <template>
                    <div v-if="merchantInfo.merchantStatus == 0">
                      {{ $t('accountmanager.active') }}
                    </div>
                    <div v-if="merchantInfo.merchantStatus == 1">
                      {{ $t('accountmanager.inactive') }}
                    </div>
                  </template>
                </td>
                <td>
                  <template>
                    <div v-if="merchantInfo.merchantModel == 1">
                      {{ $t('clientmanage.addDialog.optionModtext1') }}
                    </div>
                    <div v-if="merchantInfo.merchantModel == 2">
                      {{ $t('clientmanage.addDialog.optionModtext2') }}
                    </div>
                  </template>
                </td>
                <td>
                  {{amountData['all']}}
                </td>
                <td>
                  {{amountData['usdt_qr']}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </el-row>

      <el-row>
        <div class="detailed">
          <h2>{{ $t('merchantdetails.indetails') }}</h2>
          <table cellspacing="0" cellpadding="15">
            <thead>
              <tr>
                <template v-for="(row, index) in indetails">
                  <th :key="index">{{ $t(`clientmanage.updataDia.${row.label}`) }}</th>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr>
                <template v-for="row in indetails">
                  <td :key="row.label">
                    <span>{{ merchantInfo[row.value] }}</span>
                    <span v-if="row.value !== 'merchantWithdrawalFee' && row.value !== 'payoutFixedFee' && row.value !== 'autoPayoutFee'  ">%</span>
<!--                    <span v-if="['onlineBankingDirectConnect', 'merchantWithdrawalFee'].indexOf(row.label) === -1 "></span>-->
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </el-row>
      <!-- <el-row>
        <div class="detailed">
          <h2>{{ $t('merchantdetails.label.walletTile') }}</h2>
          <table cellspacing="0" cellpadding="15">
            <thead>
              <tr>
                <template v-for="(val, key) in walletTypes">
                  <th :key="key">{{ $t(`merchantdetails.label.${key}`) }}</th>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr>
                <template v-for="(val, key) in walletTypes">
                  <td :key="key">{{ val }}</td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </el-row> -->
    </el-card>
  </el-card>
</template>

<script>
import merchantdepositApi from '@/api/merchantdeposit';
import { mapState } from 'vuex';
export default {
  // @NOTE 不启用缓存
  // name: 'merchantInfo',
  data() {
    return {
      merchantInfo: {},
      amountData: {}
    };
  },
  computed: {
    ...mapState({
      info: ({ user }) => user.info
    }),
    walletTypes() {
      return Object.keys(this.amountData).reduce((acc, curr) => {
        if (curr === 'walletAmountTotal' || curr === 'all' || curr === 'usdt_qr') {
          return acc;
        }
        acc[curr] = this.amountData[curr];
        return acc;
      }, {});
    }
  },
  created() {
    this.indetails = [
      {
        label: 'card',
        value: 'card'
      },

      {
        label: 'momo',
        value: 'momo'
      },

      // {
      //   label: 'momoIpay',
      //   value: 'momoIpay'
      // },
      {
        label: 'onlineBankingDirectConnect',
        value: 'onlineBankingDirectConnect'
      },
      {
        label: 'onlineBankingQr',
        value: 'onlineBankingQr'
      },
      {
        label: 'vipQr',
        value: 'qrPro'
      },
      {
        label: 'viettelpay',
        value: 'viettelpay'
      },
      {
        label: 'zalo',
        value: 'zalo'
      },
      
      {
        label: 'usdt',
        value: 'usdt'
      },
      {
        label: 'payOnBehalfOf',
        value: 'payOnBehalfOf'
      },
      {
        label: 'payoutFixedFee',
        value: 'payoutFixedFee'
      },
      {
        label: 'autoPayoutFee',
        value: 'autoPayoutFee'
      },
      {
        label: 'momoBank',
        value: 'momoBank'
      },
      {
        label: 'zaloBank',
        value: 'zaloBank'
      },
      {
        label: 'vtpBank',
        value: 'vtpayBank'
      },

      // {
      //   label: 'merchantWithdrawalFee',
      //   value: 'merchantWithdrawalFee'
      // }
    ];
  },
  mounted() {
    this.getAmount();
    this.getmerchantNo();
  },

  methods: {
    async getmerchantNo() {
      const params = {
        merchantNo: this.info.userName
      };
      const { data } = await merchantdepositApi.getmerchantNo(params);
      if (data) {
        if (data.code === 200) {
          this.merchantInfo = data.data || {};
        } else {
          this.$message.error(data.msg);
        }
      }
    },
    async getAmount() {
      const params = {
        merchantNo: this.info.userName
      };
      const { data } = await merchantdepositApi.getAmount(params);
      if (data) {
        if (data.code === 200) {
          this.amountData = data.data;
        } else {
          this.$message.error(data.msg);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.basic,
.detailed,
.QRcode {
  float: left;
  margin-top: 2%;
  margin-bottom: 20px;
}
tr,
th,
td,
table {
  border: 1px solid #999999;
}
tr {
  text-align: left;
}

td {
  min-width: 150px;
  text-align: center;
}

.table {
  overflow-x: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/merchantInfo/index.vue